import { ReactElement } from 'react';

import { Typography } from '@mui/material';

interface BoldTextProps {
  children: ReactElement | string | unknown;
  [x: string]: unknown;
}

export const BoldText = ({ children, ...props }: BoldTextProps) => {
  return (
    <Typography variant="body2" {...props}>
      {children as ReactElement}
    </Typography>
  );
};
